import React from 'react';
import { Navigate } from 'react-router-dom';
import { isVendorUser } from '../utils/auth.js';

export default function VendorRoute({ children }) {
  const token = localStorage.getItem('access-token');
  if (!token) {
    return <Navigate to="/signin" replace />;
  }
  if (!isVendorUser()) {
    return <Navigate to="/home" replace />;
  }
  return children;
}
